import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { useMelwaysInfo } from '@seek/melways-react';
import React, { type ComponentProps } from 'react';
import { useDispatch } from 'react-redux';

import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';
import { headerFooterLinkClicked } from 'src/reducers/location';

import { usePersonalDetails } from '../Profile/PersonalDetails/data';

import { mapLinkAction } from './utils';

type ApacHeaderAuthenticationStatus = ComponentProps<
  typeof ApacCandidateHeader
>['authenticationStatus'];

export const HeaderContainer = () => {
  const dispatch = useDispatch();
  const authenticationStatus = useTypedSelector(
    (state) => state.user.authenticationStatus,
  );

  const { country } = useMelwaysInfo();
  const { personalDetails } = usePersonalDetails();
  const firstName = personalDetails?.personalDetails.firstName || '';
  const lastName = personalDetails?.personalDetails.lastName || '';
  const emailAddress = personalDetails?.emailAddress || '';
  const languageSwitcher =
    country === 'th' || country === 'id'
      ? {
          en: {
            url: '/profile/me',
          },
          [country]: {
            url: `/${country}/profile/me`,
          },
        }
      : undefined;

  return (
    <ApacCandidateHeaderFooterLinkProvider
      value={{
        sendLinkEvent: ({ linkContext }) => {
          dispatch(
            headerFooterLinkClicked({
              linkPosition: 'header',
              linkText: (linkContext?.source as string) || 'none',
              linkAction: linkContext?.openingOrClosing
                ? mapLinkAction(linkContext.openingOrClosing as string)
                : undefined,
            }),
          );
        },
      }}
    >
      <ApacCandidateHeader
        activePrimaryTab="profile"
        activeGlobalTab="jobs"
        activeAuthedUserTab="authedUserTabProfile"
        authenticationStatus={
          authenticationStatus as ApacHeaderAuthenticationStatus
        }
        userProfile={{
          firstName,
          lastName,
          email: emailAddress,
        }}
        languageSwitcher={languageSwitcher}
        widthMode="large"
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};
